import { useState } from "react";
import CommonModal from "./Modal/CommonModal";
import CommonModalTitle from "./Modal/CommonModalTitle";
import CargoEnquiryForm from "./ServicesFrom/CargoEnquiryForm";

export default function ConsolidatedServices() {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <div>
      <section className="pb-5 pt-0" style={{ backgroundColor: "#fff" }}>
        <div
          id="carouselExampleControls"
          className="carousel main-slider slide"
          data-bs-ride="carousel"
        >
          <div className="getquote_div text-center">
            <button
              type="button"
              onClick={handleOpen}
              className="btn getquoteBtn banner-button"
            >
              Request A Quote
            </button>
          </div>
          <div className="carousel-inner">
            <div className="carousel-item active" data-bs-interval="5000">
              {/* <img
                src="assets/images/slider/2.jpg"
                className="w-100 desktop"
                alt="Not found"
              />
              <img
                src="assets/images/slider/2_mobile.png"
                className="w-100 mobile"
                alt="Not found"
              /> */}

              <img
                src="/assets/images/consolidated-services-banner.png"
                alt="Not found"
                className="w-100 desktop"
              />
              <img
                src="/assets/images/consolidated-services-banner-mobile.webp"
                alt="Not found"
                className="w-100 mobile"
              />
            </div>

            <div className="carousel-item" data-bs-interval="5000">
              <img
                src="assets/images/consolidated-slider.png"
                className="w-100 desktop"
                alt="Not found"
              />
              <img
                src="assets/images/consolidated-slider-mobile.png"
                className="w-100 mobile"
                alt="Not found"
              />
            </div>
          </div>
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#carouselExampleControls"
            data-bs-slide="prev"
          >
            <span
              className="carousel-control-prev-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#carouselExampleControls"
            data-bs-slide="next"
          >
            <span
              className="carousel-control-next-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>

        {/* <div className="services-pages-banner">
          <div>
            <img
              src="/assets/images/consolidated-services-banner.png"
              alt="Not found"
              className="w-100"
            />
            <img
              src="/assets/images/consolidated-services-banner-mobile.webp"
              alt="Not found"
              className="w-100 service-mobile-view-banner"
            />
          </div>
          <div>
            <button
              className="btn getquoteBtn mt-5 mb-3 mx-2 text-center d-block banner-button"
              onClick={handleOpen}
            >
              <img
                src="/assets/images/arrow_right.svg"
                alt="Not found"
                height={12}
              />
              <span className="px-2 d-inline-block fw-bold p-0">
                Request A Quote
              </span>
            </button>
          </div>
        </div> */}

        <div className="container">
          <section className="courier-mode">
            <div className="row mb-5">
              <div className="col-md-6 ">
                <div className="transit-insurance-service-img">
                  <img
                    src="/assets/images/what-is-consolidation.png"
                    alt="Not found"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="transit-insurance-service">
                  <h3>What is Consolidation?</h3>
                  <h6 className="mb-3">
                    We group your purchases. You get a single, smooth delivery.
                  </h6>
                  <p>
                    When you order from different sellers or stores, World2Door
                    Cargo can consolidate all your items into a single shipment.
                    That means:
                  </p>

                  <ul>
                    <li>
                      <p>Fewer packages to track</p>
                    </li>
                    <li>
                      <p>One customs clearance</p>
                    </li>
                    <li>
                      <p>Cheaper with only one  freight charge</p>
                    </li>
                    <li>
                      <p>Faster, cleaner delivery</p>
                    </li>
                  </ul>

                  <p>
                    Perfect for shoppers buying from multiple retailers or bulk
                    buyers sourcing across categories.
                  </p>
                  <button
                    className="btn getquoteBtn mt-2 mb-0 m-0"
                    onClick={handleOpen}
                  >
                    Request a Quote
                  </button>
                </div>
              </div>
            </div>
            <div className="row mb-5">
              <div className="col-md-6">
                <div className="transit-insurance-service">
                  <h3>How You Benefit</h3>
                  <h6 className="mb-3">
                    From minor dents to partial damage or loss
                  </h6>
                  <p>
                    Hassle-free, efficient, and cost-effective. We handle the
                    documentation, compliance, and coordination, so you don’t
                    have to. More efficient. More affordable. Just smarter.
                  </p>
                  <p>
                    Consolidation dramatically reduces international shipping
                    costs by:
                  </p>

                  <ul>
                    <li>
                      <p>Minimising multiple freight charges</p>
                    </li>
                    <li>
                      <p>Lowering customs and handling fees</p>
                    </li>
                    <li>
                      <p>Eliminating the confusion of scattered deliveries</p>
                    </li>
                    <li>
                      <p>Offering a cleaner, more organised cargo process</p>
                    </li>
                  </ul>
                  <p>It’s a win-win for your wallet and your time.</p>
                  <button
                    className="btn getquoteBtn mt-2 mb-0 m-0"
                    onClick={handleOpen}
                  >
                    Request a Quote
                  </button>
                </div>
              </div>
              <div className="col-md-6 ">
                <div className="transit-insurance-service-img">
                  <img
                    src="/assets/images/how-you-benefit.png"
                    alt="Not found"
                  />
                </div>
              </div>
            </div>

            <div className="row mb-5">
              <div className="col-md-6 ">
                <div className="transit-insurance-service-img">
                  <img src="/assets/images/how-it-works.png" alt="Not found" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="transit-insurance-service">
                  <h3>How It Works</h3>
                  <p>We store, combine, and ship—all under one roof.</p>

                  <ul>
                    <li>
                      <p>You shop from multiple sellers.</p>
                    </li>
                    <li>
                      <p>
                        Each seller sends the order to our consolidation hub.
                      </p>
                    </li>
                    <li>
                      <p>
                        We receive, safely store, and club your items into a
                        single shipment.
                      </p>
                    </li>
                    <li>
                      <p>
                        You choose the shipping method. We dispatch everything
                        together.
                      </p>
                    </li>
                  </ul>
                  <p>Custom packaging and insurance available on request.</p>
                  <button
                    className="btn getquoteBtn mt-2 mb-0 m-0"
                    onClick={handleOpen}
                  >
                    Request a Quote
                  </button>
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>
      <CommonModal open={open} onClose={handleClose} fullWidth={true}>
        <CommonModalTitle>Consolidated Enquiry Form</CommonModalTitle>
        <CargoEnquiryForm handleClose={handleClose} type={"CONSOLIDATION"} />
      </CommonModal>
    </div>
  );
}
